// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid2L = class TeaserBoxInnerGrid2L extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            isPremium: this.teaserBoxConfig.isPremium,
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            showAuthorAvatar: this.teaserBoxConfig.showAuthorAvatar,
            showAuthorName: this.teaserBoxConfig.showAuthorName,
            showCategory: this.teaserBoxConfig.showCategory,
            showPublicationDate: this.teaserBoxConfig.showPublicationDate,
            showTitle: true,
            size: TileSize.L,
            titleOnImage: true,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
    }
};
TeaserBoxInnerGrid2L.moduleVersion = TeaserBoxVersion['2L'];
TeaserBoxInnerGrid2L = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid2L',
        components: { InnerGridWrapper, Tile },
        template: `
    <InnerGridWrapper>
      <Tile v-if="articles && articles.length"
            v-for="article in articles.slice(0, 2)" :key="article.id"
            v-bind="{ ...tileConfig, article, fallbackImage, windowService, isLazy, isMobile }" />
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGrid2L);
export { TeaserBoxInnerGrid2L };
